import { store } from '@/decorators/store';
import { VehiclePosition } from '@/entities/VehiclePosition';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'VehiclePositionStore' })
export class VehiclePositionStore extends AbstractEntityStore<VehiclePosition> {
  protected entityIdKey = 'vehicleId';
}
